import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	LogoImg: styled.img`
		height: 180px;
	`,

	TabDiv: styled.div`
		display: flex;
		gap: 16px;
	`,
	Tab: styled.button`
		${({theme}) => theme.font.small_bold};

		${({$selected}) =>
			$selected &&
			css`
				${({theme}) => theme.font.small_bold};
				color: ${({theme}) => theme.color.major};
			`}
	`,
}

export default Style
